module.exports = __webpack_public_path__ + "static/img/image-lite@2x.64ca715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/image-lite@2x.png
// module id = RBqV
// module chunks = 13